//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GoogleMaps from '../../components/general/GoogleMaps'
export default {
    metaInfo: {
        meta: [
            {charset: 'utf-8'},
            {
                name: 'viewport',
                content:
                    'width=device-width, initial-scale=1, user-scalable=no',
            },
        ],
    },
    data() {
        return {
            orderNo: '',
            name: '',
            selectedItemIndex: 0,
            whatsappNumber: '62109076',
            seamless: false,
            selectedItem: {},
            paymentMethods: [
                {label: 'Yappy', value: 'Yappy'},
                {label: 'Efectivo', value: 'Efectivo'},
            ],
            selectedPaymentMethod: null,
            address: '',
            total: 0,
            location: [],
            markers: [],
            center: {},
            optionsDialog: false,
            stylesDialog: false,
            successDialog: false,
            cartDialog: false,
            googleSheetLink:
                'https://script.google.com/macros/s/AKfycbxJac49DFrEX16U1v6qUpEux8gWkIAdQcis6prSE2-VW9fEsMUp/exec',
            cart: [],
            menu: [
                {
                    title: 'Corvina frita con escabeche',
                    desc:
                        'Acompañado con arroz blanco, plátano en tentación y ensalada de la casa',
                    pic: 'escabeche.jpeg',
                    styles: [],
                    options: [
                        {title: 'Arroz blanco', price: 0},
                        {title: 'Arroz con coco', price: 1.5},
                    ],
                    type: 'main',
                    price: 11,
                },
                {
                    title: 'Pulpo con leche de coco y curry',
                    desc:
                        'Acompañado con arroz blanco, plátano en tentación y ensalada de la casa',
                    pic: '',
                    styles: [],
                    options: [
                        {title: 'Arroz blanco', price: 0},
                        {title: 'Arroz con coco', price: 1.5},
                    ],
                    type: 'main',
                    price: 12.5,
                },
                {
                    title: 'Filete de pescado empanizado o en escabeche',
                    desc:
                        'Acompañado con arroz blanco , plátano en tentación y ensalada de la casa',
                    pic: '',
                    styles: [
                        {title: 'Empanizado', price: 0},
                        {title: 'Escabeche', price: 0},
                    ],
                    options: [
                        {title: 'Arroz blanco', price: 0},
                        {title: 'Arroz con coco', price: 1.5},
                    ],
                    type: 'main',
                    price: 11,
                },
                {
                    title: 'Filete de pescado empanizado (4 porciones)',
                    desc:
                        'Para 4 personas - Acompañado con arroz blanco, plátano en tentación, escabeche y ensalada de la casa.',
                    styles: [],
                    options: [
                        {title: 'Arroz con coco', price: 1.5},
                        {title: 'Papas fritas', price: 0},
                    ],
                    pic: 'familiar.jpeg',
                    type: 'main',
                    price: 28,
                },
                {
                    title: 'Kids Menu',
                    desc:
                        'Deditos de pescados empanizados acompañados de papas fritas.',
                    pic: 'kids.jpeg',
                    styles: [],
                    options: [{title: 'Papas fritas', price: 0}],
                    type: 'main',
                    price: 5,
                },
                {
                    title: 'Extras',
                    desc:
                        'Orden extra de arroz con coco, papas fritas o arroz blanco.',
                    type: 'extras',
                    styles: [],
                    options: [
                        {
                            title: 'Arroz con coco',
                            price: 2.5,
                        },
                        {
                            title: 'Orden de papas fritas',
                            price: 2,
                        },
                        {
                            title: 'Arroz con coco (4 porciones)',
                            price: 5,
                        },
                        {
                            title: 'Arroz blanco (4 porciones)',
                            price: 4,
                        },
                        {
                            title: 'Papas fritas (4 porciones)',
                            price: 4,
                        },
                    ],
                },
                {
                    title: 'Bebidas',
                    desc: 'Limonada con raspadura, Coca Cola.',
                    type: 'drinks',
                    styles: [],
                    options: [
                        {
                            title: 'Limonada con raspadura',
                            price: 2,
                        },
                        {
                            title: 'Coca Cola',
                            price: 1.5,
                        },
                    ],
                },
                {
                    title: 'Botella de picante',
                    type: 'extras',
                    styles: [],
                    options: [{title: 'Presentación de 240ml', price: 0}],
                    desc: '',
                    price: 5,
                },
            ],
        }
    },
    methods: {
        selectItem(index) {
            this.selectedItemIndex = index
            this.selectedItem = Object.assign({}, this.menu[index])
            if (this.selectedItem.styles.length > 0) {
                this.stylesDialog = true
                return
            }
            this.optionsDialog = true
        },
        checkIfDuplicate() {
            let isDuplicate = false
            if (this.cart.length <= 0) {
                isDuplicate = false
            }

            this.cart.forEach(c => {
                if (
                    c.type === this.selectedItem.type &&
                    c.title === this.selectedItem.title &&
                    c.options.title === this.selectedItem.options.title
                ) {
                    isDuplicate = true
                }
            })

            return isDuplicate
        },
        addItemToCart(section, item) {
            if (section === 'style') {
                this.selectedItem.styles = item
                this.stylesDialog = false
                this.optionsDialog = true
            } else {
                this.selectedItem.options = item
                if (!this.checkIfDuplicate()) {
                    this.selectedItem.amount = 1
                    this.cart.push(this.selectedItem)
                    this.optionsDialog = false
                    this.successDialog = true
                    this.calculateTotal()
                } else {
                    this.cart.forEach(c => {
                        if (
                            c.type === this.selectedItem.type &&
                            c.title === this.selectedItem.title &&
                            c.options.title === this.selectedItem.options.title
                        ) {
                            c.amount++
                        }
                    })
                    this.optionsDialog = false
                    this.successDialog = true
                    this.calculateTotal()
                }
            }
        },
        removeItemFromCart(i) {
            this.cart.splice(i, 1)
        },
        calculateTotal() {
            let total = 0
            this.cart.forEach(c => {
                if (c.price) total += c.price * c.amount
                if (c.options.price) total += c.options.price * c.amount
                if (c.styles.price) total += c.styles.price * c.amount
            })
            this.total = total
        },
        generateMessage() {
            let message =
                'Buenas me gustaria realizar un pedido de:%0D%0A%0D%0A'
            for (let item of this.cart) {
                message += `- (${item.amount}) ${item.title} ${
                    item.styles.title ? '- ' + item.styles.title + ' ' : ''
                }- ${item.options.title}%0D%0A`
            }
            message += `%0D%0ANo. de pedido: ${this.orderNo}%0D%0ANombre: ${this.name}`

            message += `%0D%0AUbicacion: ${this.getLocationForMessage()}%0D%0ADireccion: ${
                this.address
            }`
            message += `%0D%0AMetodo de pago: ${
                this.selectedPaymentMethod
            }%0D%0ATotal: $ ${this.total.toFixed(2)}`
            message = message.replace(/\+/g, '%2B')
            message = message.replace(/&/g, '%26')
            message = message.replace(/#/g, '%23')
            return message
        },
        async sendToGoogleDriveSheet() {
            let message = ''
            for (let item of this.cart) {
                if (item.type == 'main')
                    message += `(${item.amount}) ${item.title} con ${item.options.title}\n`
                if (item.type == 'extras')
                    message += `(${item.amount}) ${item.title} - ${item.options.title}\n`
                if (item.type == 'drinks')
                    message += `(${item.amount}) Bebida - ${item.options.title}\n`
            }
            let data = {
                id: this.orderNo,
                pedido: message,
                nombre: this.name,
                status: 'orden creada',
                direcion_1: this.getLocationForMessage(),
                direcion_2: this.address,
                total: this.total,
                metodo_de_pago: this.selectedPaymentMethod,
            }
            var url =
                'https://script.google.com/macros/s/AKfycbxJac49DFrEX16U1v6qUpEux8gWkIAdQcis6prSE2-VW9fEsMUp/exec'
            var xhr = new XMLHttpRequest()
            xhr.open('POST', url)
            // xhr.withCredentials = true;
            xhr.setRequestHeader(
                'Content-Type',
                'application/x-www-form-urlencoded'
            )
            // url encode form data for sending as post data
            var encoded = Object.keys(data)
                .map(function (k) {
                    return (
                        encodeURIComponent(k) +
                        '=' +
                        encodeURIComponent(data[k])
                    )
                })
                .join('&')
            await xhr.send(encoded)
        },
        getLocationForMessage() {
            if (this.location.length <= 0) {
                let lat = parseFloat(this.center.lat)
                let lng = parseFloat(this.center.lng)
                // if (lat < 0) lat = `+${lat}`
                // if (lng < 0) lng = `+${lng}`
                return `https://waze.com/ul?ll=${lat},${lng}&z=10`
            } else {
                let lat = parseFloat(this.location.lat)
                let lng = parseFloat(this.location.lng)
                // if (lat < 0) lat = `+${lat}`
                // if (lng < 0) lng = `+${lng}`
                return `https://waze.com/ul?ll=${lat},${lng}&z=10`
            }
        },
        setMarkerPosition(event) {
            this.location = event
        },
        geolocate() {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.center = {
                        lat: parseFloat(position.coords.latitude),
                        lng: parseFloat(position.coords.longitude),
                    }
                    this.markers.push({position: this.center})
                },
                error => {
                    this.center = {
                        lat: parseFloat(9.068463),
                        lng: parseFloat(-79.452694),
                    }
                    this.markers.push({position: this.center})
                }
            )
        },
        async sendChat() {
            if (this.name == '') {
                alert('Debes ingresar tu nombre al pedido.')
                return
            }
            if (this.address == '') {
                alert(
                    'Debes ingresar tu direccion completa para la entrega de tu pedido.'
                )
                return
            }
            if (this.selectedPaymentMethod == null) {
                alert('Debes seleccionar un metodo de pago.')
                return
            } else {
                this.orderNo = Math.floor(100000 + Math.random() * 900000)
                this.$analytics.logEvent('wp-madamecoco', {
                    content_action: 'Orden Completada',
                })
                await this.sendToGoogleDriveSheet()
                window.location.href = `https://wa.me/507${
                    this.whatsappNumber
                }?text=${this.generateMessage()}`
            }
        },
    },
    watch: {
        selectedArea() {
            this.cart = []
            this.calculateTotal()
        },
        cart() {
            this.calculateTotal()
            if (this.cart.length > 0) {
                this.seamless = true
                this.$store.commit('SET_DISPLAYFOOTER', true)
            } else {
                this.seamless = false
                this.$store.commit('SET_DISPLAYFOOTER', false)
            }
        },
    },
    components: {
        GoogleMaps,
    },
    mounted() {
        this.$store.commit('SET_DISPLAYFOOTER', false)
        let path = this.$route.params.path
        this.$analytics.logEvent('wp-madamecoco', {
            path,
        })
        this.geolocate()
    },
}
